module.exports = "/_next/static/images/dbe2ca1dc786f417e79c036a6a8a68ec-mockup-transfer-fgts@2x.jpg";